import { Translation } from 'cng-common/features/translations'
import { getFormattedFinance } from 'cng-common/helpers/numbers'
import { P360Currency } from 'partner360/models/P360Currency'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../configs/translations'
import { formatMdfContraPercent } from '../../../../lib/formatMdfContraPercent'
import { IMdfContraMetrics } from '../../../../lib/getMdfContraMetrics'
import { MdfOverviewCard } from '../../../mdfOverviewCard'

import styles from './ContraOverviewCard.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS.dashboard.overview.contra

export const ContraOverviewCard = ({ contraPercent, salesUsd }: IMdfContraMetrics) => (
  <MdfOverviewCard
    title={KEYS.title}
    titleTooltip={KEYS.tooltip}
    value={formatMdfContraPercent(contraPercent)}
    footer={
      <div className={styles.salesFooter}>
        <Translation text={KEYS.footerTitle} />
        <span className={styles.salesValue}>
          {getFormattedFinance(salesUsd, {
            withCurrencySign: true,
            currency: P360Currency.USD,
            maximumFractionDigits: 0,
          })}
        </span>
      </div>
    }
  />
)

ContraOverviewCard.displayName = 'ContraOverviewCard'
